import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChangeEffectiveDate: {
        id: 'endorsement.ea.startChangePage.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    policyChangeReason: {
        id: 'endorsement.ea.startChangePage.Policy Change Reason',
        defaultMessage: 'Policy Change Reason'
    },
    policyChangeSource: {
        id: 'endorsement.ea.startChangePage.Policy Change Source',
        defaultMessage: 'Policy Change Source'
    },
    lossOccuredBetweenDates: {
        id: "endorsement.ea.startChangePage.Has any Liability Loss occurred in the household between the effective date and today's date?",
        defaultMessage: "Has any Liability Loss occurred in the household between the effective date and today's date?"
    },
    choosePolicyChangeSource: {
        id: 'endorsement.ea.startChangePage.Policy Change Source.Choose Policy Change Source',
        defaultMessage: 'Please Select'
    },
    choosePolicyChangeReason: {
        id: 'endorsement.ea.startChangePage.Policy Change Source.Choose Policy Change Reason',
        defaultMessage: 'Please Select'
    },
    policyChangeDescripion: {
        id: 'endorsement.ea.startChangePage.Description',
        defaultMessage: 'Description'
    },
    policyChangeCancelLabel: {
        id: 'endorsement.ea.startChangePage.CancelLabel',
        defaultMessage: 'Cancel'
    },
    policyChangesaveAndExitLabel: {
        id: 'endorsement.ea.startChangePage.SaveAndExitLabel',
        defaultMessage: 'Exit'
    },
    policyChangeEffectiveDateHelpText: {
        id: 'endorsement.ea.startChangePage.Effective Date for change can be modified in the Insured screen',
        defaultMessage: 'Effective Date for change can be modified in the Insured screen'
    }
});
